import { render, staticRenderFns } from "./BookmarkList.vue?vue&type=template&id=e6d8c338&scoped=true&"
import script from "./BookmarkList.vue?vue&type=script&lang=js&"
export * from "./BookmarkList.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkList.vue?vue&type=style&index=0&id=e6d8c338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d8c338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VContainer,VIcon,VSkeletonLoader})
